/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import subDays from 'date-fns/sub_days';
import subHours from 'date-fns/sub_hours';
import subMonths from 'date-fns/sub_months';
import addHours from 'date-fns/add_hours';
import addDays from 'date-fns/add_days';
import addMonths from 'date-fns/add_months';
import startOfDay from 'date-fns/start_of_day';
import startOfHour from 'date-fns/start_of_hour';
import startOfMonth from 'date-fns/start_of_month';
import endOfHour from 'date-fns/end_of_hour';
import endOfDay from 'date-fns/end_of_day';
import isAfter from 'date-fns/is_after';
import isBefore from 'date-fns/is_before';
import min from 'date-fns/min';
import endOfMonth from 'date-fns/end_of_month';
import format from 'date-fns/format';
import { connect } from 'react-redux';
import { routerActions } from 'react-router-redux';
import { injectIntl } from 'react-intl';
import {
  Row,
  Col,
  Panel,
} from 'react-bootstrap';
import Refresher from 'loracoms/Refresher';
import InlineSelect from 'loracoms/InlineSelect';
import DatePicker from 'loracoms/DatePicker';
import Toolbar from 'loracoms/Toolbar';
import CollapseToggle from 'loracoms/CollapseToggle';
import IntlMsg from 'lorautils/intl/IntlMsg';
import gatewayActions from 'loraactions/gateway';
import GatewayPktTrend from '../GatewayPktTrend';
import GatewaySFTrend from '../GatewaySFTrend';
import GatewayFreqTrend from '../GatewayFreqTrend';
import GatewayPktPie from '../GatewayPktPie';
import GatewaySFPie from '../GatewaySFPie';
import GatewayFreqPie from '../GatewayFreqPie';
import styles from './styles.scss';


function addOne(t, by) {
  switch (by) {
    case 'YYYYMMDDHH': return addHours(t, 1);
    case 'YYYYMMDD': return addDays(t, 1);
    case 'YYYYMM': return addMonths(t, 1);
    default: return t;
  }
}

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  gatewayId: React.PropTypes.string.isRequired,
  getGatewayPktStats: React.PropTypes.func.isRequired,
  getGatewaySFStats: React.PropTypes.func.isRequired,
  getGatewayFreqStats: React.PropTypes.func.isRequired,
  pktStats: React.PropTypes.object.isRequired,
  sfStats: React.PropTypes.object.isRequired,
  freqStats: React.PropTypes.object.isRequired,
};

class GatewayPacketStat extends React.Component {

  static handleDisableDate(d, from) {
    return isAfter(d, min(addDays(from, 7), new Date())) ||
      isBefore(d, from);
  }

  constructor(props) {
    super(props);
    this.state = {
      pktStats: props.pktStats,
      sfStats: props.sfStats,
      freqStats: props.freqStats,
      by: 'YYYYMMDDHH',
      from: startOfDay(new Date()),
      to: endOfDay(new Date()),
    };
    this.handleChangeFrom = this.handleChangeFrom.bind(this);
    this.handleChangeTo = this.handleChangeTo.bind(this);
    this.loadPkts = this.loadPkts.bind(this);
    this.loadSF = this.loadSF.bind(this);
    this.loadFreq = this.loadFreq.bind(this);
    this.intlMsg = new IntlMsg(props.intl, 'gatewaydetail.statview');
  }

  componentWillMount() {
    this.loadPkts();
    this.loadSF();
    this.loadFreq();
  }

  componentWillReceiveProps(nextProps) {
    const { pktStats, sfStats, freqStats } = nextProps;
    if (pktStats !== this.props.pktStats) {
      this.setState({ pktStats });
    }
    if (sfStats !== this.props.sfStats) {
      this.setState({ sfStats });
    }
    if (freqStats !== this.props.freqStats) {
      this.setState({ freqStats });
    }
  }


  defaultFrom(by = this.state.by) {
    switch (by) {
      case 'YYYYMMDDHH':
        return startOfHour(subHours(new Date(), 24));
      case 'YYYYMMDD':
        return startOfDay(subDays(new Date(), 7));
      case 'YYYYMM':
        return startOfMonth(subMonths(new Date(), 6));
      default:
        return startOfHour(subHours(new Date(), 24));
    }
  }

  defaultTo(by = this.state.by) {
    switch (by) {
      case 'YYYYMMDDHH':
        return endOfHour(new Date());
      case 'YYYYMMDD':
        return endOfDay(new Date());
      case 'YYYYMM':
        return endOfMonth(new Date());
      default:
        return endOfHour(new Date());
    }
  }

  loadStats(func, args = {}) {
    const { gatewayId } = this.props;
    const nargs = {
      from: this.state.from,
      to: this.state.to,
      by: this.state.by,
      ...args,
    };
    const {
      by,
      from = this.defaultFrom(by),
    } = nargs;
    let { to = this.defaultTo(by) } = nargs;
    to = addOne(to, by);
    func(gatewayId, {
      from: format(from, by),
      to: format(to, by),
    });
  }

  loadPkts(args = {}) {
    const { getGatewayPktStats } = this.props;
    this.loadStats(getGatewayPktStats, args);
  }

  loadSF(args = {}) {
    const { getGatewaySFStats } = this.props;
    this.loadStats(getGatewaySFStats, args);
  }

  loadFreq(args = {}) {
    const { getGatewayFreqStats } = this.props;
    this.loadStats(getGatewayFreqStats, args);
  }

  handleChangeFrom(from) {
    const sod = startOfDay(from);
    const to = endOfDay(from);
    this.setState({ from: sod, to });
    this.loadPkts({ from: sod, to });
    this.loadSF({ from: sod, to });
    this.loadFreq({ from: sod, to });
  }

  handleChangeTo(to) {
    const eod = endOfDay(to);
    this.setState({ to: eod });
    this.loadPkts({ to: eod });
    this.loadSF({ to: eod });
    this.loadFreq({ to: eod });
  }

  handleChangeBy(by) {
    this.setState({ by });
    this.loadPkts({ by });
    this.loadSF({ by });
    this.loadFreq({ by });
  }

  renderToolbar() {
    const {
      by,
      from = this.defaultFrom(by),
      to = this.defaultTo(by),
    } = this.state;
    const icon = <span className="halflings halflings-filter" />;
    const leftTools = [{
      input: (
        <DatePicker
          date={from}
          onSelect={this.handleChangeFrom}
        />
      ),
    }, {
      input: (
        <DatePicker
          date={to}
          onSelect={this.handleChangeTo}
          disabled={d => GatewayPacketStat.handleDisableDate(d, from)}
        />
      ),
    }, {
      input: (
        <InlineSelect
          bsStyle="aisz-primary"
          options={[{
            label: this.intlMsg.msg('toolbar.bytime.hours'),
            value: 'YYYYMMDDHH',
            active: true,
          }, {
            label: this.intlMsg.msg('toolbar.bytime.days'),
            value: 'YYYYMMDD',
          }]}
          values={[by]}
          onChange={selected => this.handleChangeBy(selected[0])}
        />
      ),
    }];

    return (
      <Toolbar brandIcon={icon} leftTools={leftTools} />
    );
  }

  renderPktStats() {
    const {
      pktStats: { status },
      pktExpanded = true,
      pktResize = 0,
    } = this.state;
    const header = (
      <div>
        <span>
          { this.intlMsg.msg('packetstat.packets') }
        </span>
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.loadPkts}
              reloading={status === 'pending'}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={pktExpanded}
              onChange={(v) => { this.setState({ pktExpanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
        collapsible
        expanded={pktExpanded}
        onEntered={() => { this.setState({ pktResize: Math.random() }); }}
      >
        <Row>
          <Col md={9} className="collapse-right">
            <GatewayPktTrend resize={pktResize} />
          </Col>
          <Col md={3} className="collapse-left">
            <GatewayPktPie resize={pktResize} />
          </Col>
        </Row>
      </Panel>
    );
  }

  renderSFStats() {
    const {
      sfStats: { status },
      sfExpanded = true,
      sfResize = 0,
    } = this.state;
    const header = (
      <div>
        { this.intlMsg.msg('packetstat.bysf') }
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.loadSF}
              reloading={status === 'pending'}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={sfExpanded}
              onChange={(v) => { this.setState({ sfExpanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
        collapsible
        expanded={sfExpanded}
        onEntered={() => { this.setState({ sfResize: Math.random() }); }}
      >
        <Row>
          <Col md={9} className="collapse-right">
            <GatewaySFTrend resize={sfResize} />
          </Col>
          <Col md={3} className="collapse-left">
            <GatewaySFPie resize={sfResize} />
          </Col>
        </Row>
      </Panel>
    );
  }

  renderFreqStats() {
    const {
      freqStats: { status },
      freqExpanded = true,
      freqResize = 0,
    } = this.state;
    const header = (
      <div>
        { this.intlMsg.msg('packetstat.byfreq') }
        <ul className="icontools">
          <li>
            <Refresher
              onReload={this.loadFreq}
              reloading={status === 'pending'}
            />
          </li>
          <li>
            <CollapseToggle
              expanded={freqExpanded}
              onChange={(v) => { this.setState({ freqExpanded: v }); }}
            />
          </li>
        </ul>
      </div>
    );

    return (
      <Panel
        bsStyle="aisz-white"
        header={header}
        collapsible
        expanded={freqExpanded}
        onEntered={() => { this.setState({ freqResize: Math.random() }); }}
      >
        <Row>
          <Col md={9} className="collapse-right">
            <GatewayFreqTrend resize={freqResize} />
          </Col>
          <Col md={3} className="collapse-left">
            <GatewayFreqPie resize={freqResize} />
          </Col>
        </Row>
      </Panel>
    );
  }

  render() {
    return (
      <div className={styles.packets}>
        {this.renderToolbar()}
        <ul className={styles.panels}>
          <li>{this.renderPktStats()}</li>
          <li>{this.renderSFStats()}</li>
          <li>{this.renderFreqStats()}</li>
        </ul>
      </div>
    );
  }
}

GatewayPacketStat.propTypes = propTypes;

const mapStateToProps = state => ({
  pktStats: state.gateway.getGatewayPktStats,
  sfStats: state.gateway.getGatewaySFStats,
  freqStats: state.gateway.getGatewayFreqStats,
});

const mapDispatchToProps = {
  pushState: routerActions.push,
  getGatewayPktStats: gatewayActions.getGatewayPktStats,
  getGatewaySFStats: gatewayActions.getGatewaySFStats,
  getGatewayFreqStats: gatewayActions.getGatewayFreqStats,
  getGatewayTOAStats: gatewayActions.getGatewayTOAStats,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(GatewayPacketStat));




// WEBPACK FOOTER //
// ./src/containers/Gateway/coms/GatewayDetail/coms/GatewayPacketStat/index.jsx